<template>
  <!-- <el-dropdown trigger="hover">
    <el-button type="primary">
      新建订单<i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="create(1)">线上京东自营</el-dropdown-item>
      <el-dropdown-item @click.native="create(2)">线上小平台</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown> -->
  <el-tooltip
    effect="dark"
    content="线上小平台订单"
    placement="bottom-start">
    <el-button
      type="primary"
      @click="fetchList">
      新建订单
    </el-button>
  </el-tooltip>

</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CreateOrderBtn',
  components: { },
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    create(departmentId) {
      this.$router.push(`/orders-create?vendorId=${this.userInfo.orgId}&departmentId=${departmentId}`)
    },
    fetchList() {
      this.$store.dispatch('product/getordersource', {
        payload: {
          orderSource: 5
        },
        success: (res) => {
          this.create(res.data.departmentId)
        },
        fail: () => {
          // this.list = []
        }
      })
    }
  }
}
</script>
